import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,{attrs:{"link":"","to":_vm.item.pgmId,"active-class":"secondary"}},[_c(VListItemIcon),_c(VListItemTitle,{staticClass:"nav_title--text"},[_vm._v(" "+_vm._s(_vm.item.ename)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }